import { API, Auth } from "aws-amplify";
import { showToast } from "../../components/ToastUtils";
import { ListByCustomerAddressList, ListByCustomerSalesBlockDetails, restrictCustomerSpecificProductsByCustomerUUID, SearchByProductList, userCartsByCartId, userFavouriteProductsByOwner } from "../MutaionsAndQueries";
import { GetUOMCodeList, listOrganizationDetails, notificationsByCustomerIdAndCreatedAt } from "../../graphql/queries";

// Customer and Admin Organization Details API
export const OraganizationLists = async ({ t }) => {
    try {
        const response = await API.graphql(
            {
                query: listOrganizationDetails
            }
        )
        const items = response.data.listOrganizationDetails.items[0]
        if (items) {
            return { apiResponse: items, orgDetailsshow: "Hide" }

        }
        else {
            return { apiResponse: "Empty", orgDetailsshow: "Info" }
        }

    }
    catch (error) {
        console.error("Organizations List error", error);
        showToast(`${t('Something went wrong. Please contact the admin.')}`, "error", 5000);
        return { apiResponse: "Empty", orgDetailsshow: "Info" }
    }
}
// Customer Address Details API
export const fetchCustomerAddress = async ({ t }) => {
    try {
        const response = await API.graphql({
            query: ListByCustomerAddressList
        })
        return response.data.ListByCustomerAddressList.items[0]
        // setuserAddress(response.data.ListByCustomerAddressList.items[0].CustomerAddressInformation);
        //   setaccountDetails(response.data.ListByCustomerAddressList.items[0]);
    }
    catch (error) {
        // showToast(` ${error.errors[0].message}`, "error");
        showToast(t(`Address details unavailable. Please contact admin for assistance.`), 'error')
        console.error("listByCustomerAddressList ERROR", error);
        return "NoAddress"
        //   setaccountDetails("NoAddress")

    }
}
// Customer and Admin Notification Details API
export const fetchNotificationDetails = async ({ role, t }) => {
    const userDetails = await Auth.currentAuthenticatedUser();
    // console.log("userDetails", userDetails)
    const FilterId = role === 'Customers' ? userDetails.signInUserSession.idToken.payload["custom:contactperson_UUID"] : userDetails.signInUserSession.idToken.payload.sub + "-" + userDetails.signInUserSession.idToken.payload["custom:tenant"];
    // console.log("FilterId", FilterId)
    try {
        const notificationResponse = await API.graphql({
            query: notificationsByCustomerIdAndCreatedAt,
            variables: {
                CustomerId: FilterId,
                sortDirection: 'DESC',
                filter: {
                    NotificationStatus: { eq: "Unread" },
                },
            },
        })
        // console.log("notificationResponse", notificationResponse)
        return { apiResponse: notificationResponse.data.notificationsByCustomerIdAndCreatedAt.items, sessionExpired: false }
        // setNotificationMsg(notificationResponse.data.notificationsByCustomerIdAndCreatedAt.items)
    }
    catch (error) {
        console.error("Notification Catch  Error", error);
        showToast(t(`Something went wrong. Please contact the admin.`), 'error', 4000);

        if (error.message && error.message.includes('No current user')) {
            console.error('Session timeout or unauthenticated state detected:', error);
            return { apiResponse: [], sessionExpired: true }
            // setIsSessionExpired(true);
        }
    }
}
// Customer Block list details API
export const FetchCustomerBlockDetails = async ({ t, taxDetails }) => {
    let BlockList;
    try {
        const response = await API.graphql({
            query: ListByCustomerSalesBlockDetails
        })
        // console.log("response", response)
        if (response && response.data && response.data.ListByCustomerSalesBlockDetails && response.data.ListByCustomerSalesBlockDetails.items[0]) {
            // setSalesBlockList(response.data.ListByCustomerSalesBlockDetails.items[0].SaleOrderBlockedIndicator);
            BlockList = response.data.ListByCustomerSalesBlockDetails.items[0];
            // BlockList = {
            //   DeliveryBlockedIndicator: true,
            //   InvoiceBlockedIndicator: true,
            //   SaleOrderBlockedIndicator: true
            // }
            if (BlockList.SaleOrderBlockedIndicator && BlockList.DeliveryBlockedIndicator && BlockList.InvoiceBlockedIndicator) {
                showToast(t(`Order, delivery and invoice has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
            }
            else
                if (BlockList.SaleOrderBlockedIndicator && BlockList.DeliveryBlockedIndicator) {
                    showToast(t(`Order and delivery has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
                }
                else
                    if (BlockList.SaleOrderBlockedIndicator && BlockList.InvoiceBlockedIndicator) {
                        showToast(t(`Order and invoice has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
                    }
                    else
                        if (BlockList.DeliveryBlockedIndicator && BlockList.InvoiceBlockedIndicator) {
                            showToast(t(`Delivery and invoice has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
                        }
                        else
                            if (BlockList.DeliveryBlockedIndicator) {
                                showToast(t(`Delivery has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
                            }
                            else
                                if (BlockList.InvoiceBlockedIndicator) {
                                    showToast(t(`Invoice has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
                                }
                                else if (BlockList.SaleOrderBlockedIndicator === true) {
                                    showToast(t(`Orders has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
                                }
            return response.data.ListByCustomerSalesBlockDetails.items[0].SaleOrderBlockedIndicator;
        }
        else {
            BlockList = true;
            if (BlockList === true) {
                showToast(t(`Orders,delivery and invoice has been blocked by ${taxDetails.CompanyName}. Please contact admin.`))
            }
            return true;
        }


    } catch (error) {
        console.error("Customer Block Details", error);
        return true;
    }
}
// Customer Specific Restricted Products Details API
export const FetchRestrictCustomerSpecificProductsByCustomerUUID = async ({ ProductRelatedDispatch, Actions }) => {
    const userDetails = await Auth.currentAuthenticatedUser();
    let nextToken = null;
    let RestrictProductList = [];
    try {
        do {
            const RestrictProductResponse = await API.graphql({
                query: restrictCustomerSpecificProductsByCustomerUUID,
                variables: {
                    CustomerUUID: userDetails.signInUserSession.idToken.payload["custom:customer_UUID"],
                    limit: 10000,
                    nextToken: nextToken,
                }

            })
            nextToken = RestrictProductResponse.data.restrictCustomerSpecificProductsByCustomerUUID.nextToken;
            RestrictProductList = RestrictProductResponse.data.restrictCustomerSpecificProductsByCustomerUUID.items.concat(RestrictProductList)
        } while (nextToken);

        if (RestrictProductList.length > 0) {
            const RestProdIDs = RestrictProductList.map(p => (p.ProductID + "-" + p.tenant));
            ProductRelatedDispatch({
                type: Actions.RestrictProductListDataLoaded,
                payload: { Status: "Success", Data: RestProdIDs }
            })
        }
        else {
            ProductRelatedDispatch({
                type: Actions.RestrictProductListDataLoaded,
                payload: { Status: "NoData", Data: [] }
            })
            return []
        }
    } catch (error) {
        console.error("fetchRestrictCustomerSpecificProductsByCustomerUUID error", error);
        ProductRelatedDispatch({
            type: Actions.RestrictProductListDataLoaded,
            payload: { Status: "NoData", Data: [] }
        })
    }
}
// Customer Cart Details API
export const FetchCartDetailsFn = async ({ CartRelatedDispatch, Actions }) => {
    try {
        let nextToken = null;
        let UserCartParticulars = [];
        const userDetails = await Auth.currentAuthenticatedUser();
        do {

            const UserCartResponse = await API.graphql({
                query: userCartsByCartId,
                variables: {
                    CartId: userDetails.signInUserSession.idToken.payload.sub,
                    filter: {
                        or: [
                            { CartStatus: { eq: "Open" } },
                            { CartStatus: { eq: "InProgress" } }
                        ],
                    },
                    limit: 10000,
                    nextToken: nextToken,
                },
            });

            nextToken = UserCartResponse.data.userCartsByCartId.nextToken;
            const UserCartDetail = UserCartResponse.data.userCartsByCartId.items;
            UserCartParticulars = UserCartParticulars.concat(UserCartDetail);
        } while (nextToken);


        if (UserCartParticulars.length === 0) {
            CartRelatedDispatch({ type: Actions.CartDetailsLoaded, payload: { Status: "NoCart", Data: [] } });
            CartRelatedDispatch({ type: Actions.CartProductsEmpty });
        }
        else if (UserCartParticulars.length > 0) {
            CartRelatedDispatch({
                type: Actions.CartDetailsLoaded, payload: {
                    Status: UserCartParticulars[0].CartStatus,
                    Data: UserCartParticulars[0]
                }
            })
            if (UserCartParticulars[0].Userproductcarts.items.length > 0) {
                const CartProductIDs = UserCartParticulars[0].Userproductcarts.items.map(p => p.userProductsCartProductdetailsId)
                CartRelatedDispatch({
                    type: Actions.CartProductsLoaded, payload: {
                        // when place the order that time refresh the page  condition checking 
                        Status: UserCartParticulars[0].CartStatus === "InProgress" ? "InProgress" : "ProductsInCart",
                        Data: UserCartParticulars[0].Userproductcarts.items, CartProductsIDs: CartProductIDs
                    }
                })
            }
            else if (UserCartParticulars[0].Userproductcarts.items.length === 0) {
                CartRelatedDispatch({ type: Actions.CartProductsEmpty });
            }
        }

    } catch (error) {
        console.error("FetchCartDetailsFn error:", error);
        CartRelatedDispatch({ type: Actions.CartDetailsLoaded, payload: { Status: "ErrorCart", Data: [] } });
        CartRelatedDispatch({ type: Actions.CartProductsEmpty });
    }
}
// Customer Products Open Search API
export const OpenSearchProductsDetails = async ({ SearchText, StartFrom, ProductRelatedDispatch, Actions, ProductCountSize }) => {
    const userDetails = await Auth.currentAuthenticatedUser();
    try {
        const ProductDetailsResponse = await API.graphql({
            query: SearchByProductList,
            variables:
            {
                q: SearchText,
                tenant: userDetails.signInUserSession.idToken.payload["custom:tenant"],
                from: StartFrom,
                size: ProductCountSize
            }
        })
        if (ProductDetailsResponse?.data?.SearchByProductList?.TotalValue > 0) {
            if (StartFrom === 0) {
                ProductRelatedDispatch({
                    type: Actions.CatalogProductListDataLoaded,
                    payload: { Data: ProductDetailsResponse.data.SearchByProductList }
                })
            }
            else if (StartFrom > 0) {
                ProductRelatedDispatch({
                    type: Actions.CatalogProductListConcatenate,
                    payload: { Data: ProductDetailsResponse.data.SearchByProductList }
                })
            }

        }
        else {
            ProductRelatedDispatch({ type: Actions.EmptyCatalogList })
        }

    } catch (error) {
        ProductRelatedDispatch({ type: Actions.EmptyCatalogList })
        console.error('OpenSearchProductsDetails Error:', error);
    }
}
// Customer Favorite Products API
export const FetchFavProductsDetails = async ({ ProductRelatedDispatch, Actions }) => {
    const userDetails = await Auth.currentAuthenticatedUser();
    let nextToken = null;
    let TenentFavList = [];

    try {
        do {
            const result = await API.graphql({
                query: userFavouriteProductsByOwner,
                variables: {
                    owner: userDetails.signInUserSession.accessToken.payload.sub,
                    limit: 10000,
                    nextToken: nextToken,
                }
            })
            nextToken = result.data.userFavouriteProductsByOwner.nextToken;
            TenentFavList = result.data.userFavouriteProductsByOwner.items.concat(TenentFavList)
        } while (nextToken);
        if (TenentFavList.length === 0) {
            ProductRelatedDispatch({ type: Actions.EmptyFavList })
        }
        else if (TenentFavList.length > 0) {
            ProductRelatedDispatch({ type: Actions.FavProductsListDataLoaded, payload: { Data: TenentFavList } })
        }

    }
    catch (error) {
        console.error("Fetching Fav details Error", error);
        ProductRelatedDispatch({ type: Actions.EmptyFavList })
    }
}

// Customer Products all UOM API
export const FetchUOMDetails = async ({ ProductRelatedDispatch, Actions }) => {
    try {
        const result = await API.graphql({
            query: GetUOMCodeList
        })
        ProductRelatedDispatch({
            type: Actions.UOMlistDataLoaded, payload: {
                Status: result?.data?.GetUOMCodeList?.items.length > 0 ? "Success" : "NoData",
                Data: result.data.GetUOMCodeList.items
            }
        })
    } catch (error) {
        ProductRelatedDispatch({ type: Actions.UOMlistDataLoaded, payload: { Status: "NoData", Data: [] } })
        console.error("Fetching All UOM Details:", error)
    }
}